import { render, staticRenderFns } from "./CredentialsView.vue?vue&type=template&id=0225945b&lang=pug&"
import script from "./CredentialsView.vue?vue&type=script&lang=ts&"
export * from "./CredentialsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports